var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapperx"},[_c('div',{staticClass:"full-area padded vertically-centered desktop-wrapper logo-wrapper"},[_c('SensataSplash')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }